
export type GetDashboardActivities200ActivitiesItem = {
  description?: string;
  id?: string;
  timestamp?: string;
  type?: string;
};
